import React from 'react';
import Grid from '@mui/material/Grid';
import LoadingDialog from '../../Loading';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';

import { ThemeProvider, createTheme } from '@mui/material/styles'
import InspectionAttachedFilesUpload from './attachedFilesUpload';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { alpha } from '@mui/material/styles';


const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})


export default function attachedFilesForm(props) {

    //添付画像プレビュー表示
    const onClickShowPreviewImg = (index) => {
        props?.PreviewImgIndex(index)
        props?.InspectionPreviewDialogOPEN(true)
    }

    //添付PDFプレビュー表示
    const onClickShowPreviewPDF = (index) => {
        props?.PreviewPDFIndex(index)
        props?.InspectionPreviewPDFDialogOPEN(true)
    }


    //添付画像削除確認表示
    const onClickAttachedImageDelete = (index) => {
        props?.PrevDelIndex(index)
        props?.PreviewImgDelDialog(true)
    }

    //添付PDF削除確認表示
    const onClickAttachedPDFDelete = (index) => {
        props?.PrevPDFDelIndex(index)
        props?.PreviewPDFDelDialog(true)
    }
    let previewIndex = 0;
    return (
        <React.Fragment>
            <ThemeProvider theme={inspectionTheme}>
                <Grid >
                    <LoadingDialog load={false} />
                    <CssBaseline />
                    <Grid sx={{ pl: 0 }} >
                        <Grid container rowSpacing={{ xs: 2 }} columnSpacing={2}
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                            <Grid item >
                                <Typography sx={{ fontSize: '18px' }}>添付ファイル</Typography>
                            </Grid>
                            <Grid item >
                                <InspectionAttachedFilesUpload
                                    keyData={props.keyData}
                                    setAttachedFileStatus={props?.setAttachedFileStatus}
                                    attachedData={props?.attachedData}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ImageList sx={{ width: '100%', height: 'auto' }} cols={5} rowHeight={120}>
                                    {props?.attachedData.map((item, index) => {
                                        const isImg = item.fileType !== 'PDF'
                                        const currentIndex = isImg ? previewIndex++ : null;
                                        return (
                                            item.fileType !== 'PDF' ?
                                                <ImageListItem style={{ position: "relative", }} key={index}>
                                                    <img
                                                        src={item.src}
                                                        alt=""
                                                        loading="eager"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectfit: "cover"
                                                        }}
                                                        onClick={() => onClickShowPreviewImg(currentIndex)}
                                                    />
                                                    <IconButton
                                                        sx={{
                                                            bgcolor: alpha("#C0C0C0", 0.8), fontSize: '2rem', px: 2, py: 2,
                                                            "&:hover": {
                                                                bgcolor: alpha("#a9a9a9", 0.5)
                                                            },
                                                            display: props?.keyData?.status !== 4 && props?.keyData?.canEdit ? "inline-flex" : "none"
                                                        }}
                                                        style={{
                                                            position: "absolute",
                                                            right: 0,
                                                            top: 0,
                                                            borderRadius: "50px",
                                                            zIndex: 999,

                                                        }}
                                                    >
                                                        <DeleteForeverIcon
                                                            sx={{ fontSize: '25px', color: '#d32f2f' }}
                                                            onClick={() => onClickAttachedImageDelete(index)}
                                                            disabled={props?.keyData?.status !== 4 ? true : false}
                                                        />
                                                    </IconButton>

                                                </ImageListItem>
                                                : <Grid style={{ position: "relative", }} key={index}>
                                                    < PictureAsPdfIcon
                                                        sx={{ fontSize: "100px", color: "#d32f2f" }}
                                                        onClick={() => onClickShowPreviewPDF(index)}
                                                    />
                                                    < Typography sx={{ px: 2 }} >{item.Name?.slice(0, 5) + '...'}</Typography>
                                                    <IconButton
                                                        sx={{
                                                            bgcolor: alpha("#C0C0C0", 0.8), fontSize: '2rem', px: 2, py: 2,
                                                            "&:hover": {
                                                                bgcolor: alpha("#a9a9a9", 0.5)
                                                            },
                                                            display: props?.keyData?.status !== 4 ? "inline-flex" : "none"
                                                        }}
                                                        style={{
                                                            position: "absolute",
                                                            right: 0,
                                                            top: 0,
                                                            borderRadius: "50px",
                                                            zIndex: 999
                                                        }}
                                                    >
                                                        <DeleteForeverIcon
                                                            sx={{
                                                                fontSize: '25px'
                                                                , color: '#d32f2f'
                                                                , display: props?.keyData?.status !== 4 ? "inline-flex" : "none"
                                                            }}
                                                            disabled={props?.keyData?.status === 4 ? true : false}
                                                            onClick={() => onClickAttachedPDFDelete(index)}
                                                        />
                                                    </IconButton>
                                                </Grid>
                                        )
                                    })}
                                </ImageList>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ThemeProvider >
        </React.Fragment>
    );
}